import { INSTRUMENT_SECTION_MAP } from '../../utils/constants_harmony.js';
import { BassPatternStrategy } from './sections/BassPatternStrategy.js';
import { RhythmPatternStrategy } from './sections/RhythmPatternStrategy.js';
import { HarmonyPadPatternStrategy } from './sections/HarmonyPadPatternStrategy.js';
import { MelodyPatternStrategy } from './sections/MelodyPatternStrategy.js';
import { CounterPatternStrategy } from './sections/CounterPatternStrategy.js';
import { PercussionPatternStrategy } from './sections/PercussionPatternStrategy.js';
import { AtmospherePatternStrategy } from './sections/AtmospherePatternStrategy.js';

export class SectionPatternStrategyEngine {
  constructor() {
    this.bass = new BassPatternStrategy();
    this.rhythm = new RhythmPatternStrategy();
    this.harmony = new HarmonyPadPatternStrategy();
    this.melody = new MelodyPatternStrategy();
    this.counter = new CounterPatternStrategy();
    this.percussion = new PercussionPatternStrategy();
    this.atmosphere = new AtmospherePatternStrategy();
  }

  getSectionForRole(roleId) {
    return INSTRUMENT_SECTION_MAP[roleId] || 'rhythm';
  }

  generateBarPattern(ctx, roleId, baseDegree, octaveOffset, seed) {
    const section = this.getSectionForRole(roleId);
    const oct = ctx.octave + octaveOffset;
    const chord = ctx.getCurrentChord();
    const bpb = ctx.beatsPerBar;
    const genre = ctx.genre;

    let s = seed;
    const rand = () => {
      s = (s * 16807 + 0) % 2147483647;
      return (s & 0x7fffffff) / 0x7fffffff;
    };

    if (section !== 'bass' && section !== 'percussion') {
      if (rand() > ctx.planetDensity) return [];
    }

    let pattern;
    switch (section) {
      case 'bass':
        pattern = this.bass.generate(ctx, chord, oct, baseDegree, rand, bpb, genre);
        break;
      case 'rhythm':
        pattern = this.rhythm.generate(ctx, chord, oct, baseDegree, rand, bpb, genre);
        break;
      case 'harmony':
        pattern = this.harmony.generate(ctx, chord, oct, baseDegree, rand, bpb, genre);
        break;
      case 'melody':
        pattern = this.melody.generate(ctx, chord, oct, baseDegree, rand, bpb, genre);
        break;
      case 'counter':
        pattern = this.counter.generate(ctx, chord, oct, baseDegree, rand, bpb, genre);
        break;
      case 'percussion':
        pattern = this.percussion.generate(ctx, chord, oct, baseDegree, rand, bpb, genre);
        break;
      case 'atmosphere':
        pattern = this.atmosphere.generate(ctx, chord, oct, baseDegree, rand, bpb, genre);
        break;
      default:
        pattern = this.rhythm.generate(ctx, chord, oct, baseDegree, rand, bpb, genre);
    }

    if (ctx.swing > 0 && pattern) {
      for (const evt of pattern) evt.beat = ctx.swingBeat(evt.beat);
    }

    return pattern || [];
  }
}
